export default __webpack_public_path__ + "static/media/unsere_haeuser_web-md@2x.4da8bf1e.jpg";